import Cash from './cash.jpg'
import Cashback from './cash.png'
import Calculator from './calculator.png'
import Cover from './cover_pic.jpg'
import Campaign from './svg/Campaign'
import Sale from './svg/Sale'
import Contact from './svg/Contact'
import Logo from './reachafrika-logo.svg'
import Logo_sm from './reachafrika-icon.svg'
import Transaction from './transaction.jpg'
import Wallet from './wallet.jpg'
import Bank from './bank.png'
import Store from './store.png'
import Usergroup from './user-group.png'
import Vault from './vault.png'
import Contacts from './contacts.png'
import ChartIcon from './svg/ChartIcon'
import TrashIcon from './svg/TrashIcon'
import PauseIcon from './svg/PauseIcon'
import EyeIcon from './svg/EyeIcon'
import EmptyCred from './emptycredit.png'

const images = {
  Vault,
  Cash,
  Cashback,
  Contacts,
  Cover,
  Calculator,
  Campaign,
  ChartIcon,
  PauseIcon,
  EyeIcon,
  TrashIcon,
  Logo,
  Logo_sm,
  Transaction,
  Wallet,
  Bank,
  Store,
  Usergroup,
  Sale,
  Contact,
  EmptyCred
}

export default images

